import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { useMyFolders } from '../context/MyFolders';

const SortLinesIcon = ({ isAscendant }: { isAscendant: boolean }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    {isAscendant ? (
      <>
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="12" x2="14" y2="12" />
        <line x1="4" y1="18" x2="9" y2="18" />
      </>
    ) : (
      <>
        <line x1="4" y1="6" x2="9" y2="6" />
        <line x1="4" y1="12" x2="14" y2="12" />
        <line x1="4" y1="18" x2="20" y2="18" />
      </>
    )}
  </svg>
);

const SortButton: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useMyFolders();

  const sortIcon = data.sortOrder === 'desc' ? 'ni-sort-z-a' : 'ni-sort-a-z';

  const sortLabel =
    data.sortOrder === 'desc' ? `${t('Name')} · Z → A` : `${t('Name')} · A → Z`;

  const isAscendant = data.sortOrder === 'asc' || !data.sortOrder;

  return (
    <div className="folder-grid__toolbar">
      <button
        type="button"
        className="sort-btn"
        onClick={actions.handleToggleSort}
      >
        <em className={`icon ni sort-btn__icon ${sortIcon}`} />
        <SortLinesIcon isAscendant={isAscendant} />
        <span className="sort-btn__field">{sortLabel}</span>
      </button>
    </div>
  );
};

export default SortButton;
